import React from 'react';
import PropTypes from 'prop-types';
import SelectWithValidation from 'components/SelectWithValidation';
import styles from './styles.scss';

export const FORM_FIELD_CUSTOM_EVENT_TYPE = 'customEventType';

const BulkActionSenderForm = ({
  eventTypeValue,
  setEventTypeValue,
  eventTypeOptions,
  validationError,
  setValidationError,
}) => {
  const customEventTypeChangeHandler = event => {
    setEventTypeValue(event.value);

    if (event.value && validationError?.[FORM_FIELD_CUSTOM_EVENT_TYPE]) {
      const rest = Object.fromEntries(
        Object.entries(validationError).filter(([key]) => key !== FORM_FIELD_CUSTOM_EVENT_TYPE),
      );

      setValidationError(rest);
    }
  };

  return (
    <div className={styles.inputGroupWrapper}>
      <SelectWithValidation
        name={FORM_FIELD_CUSTOM_EVENT_TYPE}
        label="Custom event"
        required
        placeholder="Select custom event"
        options={eventTypeOptions}
        value={eventTypeValue}
        errors={validationError}
        onChange={customEventTypeChangeHandler}
      />
    </div>
  );
};

BulkActionSenderForm.propTypes = {
  eventTypeValue: PropTypes.string,
  setEventTypeValue: PropTypes.func.isRequired,
  eventTypeOptions: PropTypes.array.isRequired,
  validationError: PropTypes.object,
  setValidationError: PropTypes.func,
};

BulkActionSenderForm.defaultProps = {
  eventTypeValue: '',
  validationError: {},
  setValidationError: () => {},
};

export default BulkActionSenderForm;
